import { Button, Grid, IconButton, Typography } from '@mui/material'
import React, { useState } from 'react'
import { CloseOutlined } from '@mui/icons-material'
import CustomTable from '../customTable'
import _ from 'lodash'
import moment from 'moment'

const PaymentDetails = ({setOpen,data,payData}) => {
    const pageOption = [10, 25, 50, 100];
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
    const [pageCount, setPageCount] = useState(0);
    const columns = [
        {
            field : 'sno',
            headerName : 'S.no',
            minWidth : 70,
            maxWidth : 100,
            headerAlign : 'center',
            align : 'center',
            sortable: false
          },
          {
            field: "paymentId",
            headerName: "Payment Id",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "date",
            headerName: "Date",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "invoice_no",
            headerName: "Invoice No",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },
          {
            field: "pendingAmount",
            headerName: "Pending Amount",
            flex: 1,
            headerAlign: "center",
            align: "center",
            sortable: false,
          },

          {
            field: "amount",
            headerName: "Amount",
            flex: 1,
            headerAlign: "center",
            align: "right",
            sortable: false,
            renderCell: (params) => (
              <strong>{params.value}</strong>
            ),
          },
    ]
    const rows = _.map(payData.payment_lines,(value,idx) =>({
        id: idx,
        sno: idx+1,
        paymentId:value.pm_id,
        date:moment(value.date).format('DD-MM-YYYY'),
        amount:value.amount,
        invoice_no:value.invoice_no,
        pendingAmount:value.pending_amount
    }))
    const props = {
        columns : columns,
        rows : rows,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        pageCount: pageCount,
        pageOption: pageOption,
      }
      console.log(data )
      console.log(payData)
  return (

    <Grid  sx={{
        width: "80%",
        maxHeight: "80vh",
        backgroundColor: "#fff",
        borderRadius: "5px",
      }}>
         <Grid sx={{display:"flex" , justifyContent:"space-between",padding:1,alignItems:"center"}}>
            <Typography variant='h6'>Payment Details</Typography>
            <IconButton onClick={() => setOpen(false)}>
                <CloseOutlined />
            </IconButton>
        </Grid>
        <CustomTable props={props}/>
    </Grid>
  )
}

export default PaymentDetails